import React from 'react';
import { connect } from 'react-redux';
import * as R from 'ramda';

import AccountGroupForm from '../../components/forms/AccountGroupForm';
import * as accountGroupsActions from '../../actions/entities/AccountGroupsActions';
// import { PRICE_PACKAGES } from '../../constants/Constants';

class AccountGroupContainer extends React.Component {
  componentDidMount() {
    const { fetchAccountGroup, resetCurrentGroup, match: { params: { groupId } } } = this.props;
    if (groupId) {
      fetchAccountGroup(groupId);
    } else {
      resetCurrentGroup();
    }
  }

  handleSubmit = values => {
    const { createAccountGroup, updateAccountGroup, currentGroup } = this.props;
    const data = {
      ...currentGroup,
      name: values.name.trim(),
      defaultForLanguage: values.defaultForLanguage,
      customPriceListEnabled: values.customPriceListEnabled,
      customPriceList: {
        packages: R.reduce((rv, { id, label, ...v }) => ({ ...rv, [id]: v }), {}, values.customPricePackages)
      }
    };
    if (data.id) {
      updateAccountGroup(data);
    } else {
      createAccountGroup(data);
    }
  };

  render() {
    const { currentGroup } = this.props;
    return (
      <div className="flex flex1">
        <AccountGroupForm onSubmit={this.handleSubmit} currentGroup={currentGroup} />
      </div>
    )
  }
}

export default connect(
  state => ({ currentGroup: state.entities.accountGroups.currentGroup }),
  accountGroupsActions
)(AccountGroupContainer);



// WEBPACK FOOTER //
// ./src/containers/private/AccountGroupContainer.js